const SAVE = "SAVE_ORDER";

export function save(data) {
    return {
        type: SAVE,
        payload: data
    }
}